import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RawDocumentInterface } from '../interfaces/raw-document.interface';
import { Document } from '../models/document.model';
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({ providedIn: 'root' })
export class FoldersService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get all documents.
   *
   * @param projectId ProjectId.
   * @returns BydModels of Documents.
   */
  public getAllFoldersTree(projectId: number): Observable<Document> {
    this.path = `/v1/bimdata/projects/${projectId}/dms-tree`;
    return this.get<RawDocumentInterface>().pipe(map((document: RawDocumentInterface) => new Document(document)));
  }

  /**
   * Create new folder.
   *
   * @param projectId Poject id.
   * @param parentId Parent id.
   * @param name folder name.
   * @returns Created Document.
   */
  public createFolder(projectId: number, parentId: number, name: string): Observable<Document> {
    this.path = `/v1/bimdata/projects/${projectId}/folder`;
    const data = { name, parent_id: parentId };
    return this.post<RawDocumentInterface>({ body: data }).pipe(
      map((document: RawDocumentInterface) => new Document(document))
    );
  }

  /**
   * Rename folder.
   *
   * @param projectId project ID.
   * @param folderId folder id.
   * @param name Name.
   * @returns Updated Document.
   */
  public renameFolder(projectId: number, folderId: number, name: string): Observable<Document> {
    this.path = `/v1/bimdata/projects/${projectId}/folder/${folderId}`;
    const data = { name };
    return this.patch<RawDocumentInterface>({ body: data }).pipe(
      map((document: RawDocumentInterface) => new Document(document))
    );
  }

  /**
   * Delete folder.
   *
   * @param projectId number
   * @param folderId number
   * @returns empty observable.
   */
  public deleteFolder(projectId: number, folderId: number): Observable<void> {
    this.path = `/v1/bimdata/projects/${projectId}/folder/${folderId}`;
    return this.delete<void>();
  }

  /**
   * Create Document instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `Document` instance.
   */
  public createNewInstance(jsonObject: RawDocumentInterface): Document {
    return new Document(jsonObject);
  }
}
